import { NetworkTaxonomyData } from "@app/network-taxonomies/networkTaxonomy";
import NetworkTaxonomyContentPanel from "@app/network-taxonomies/NetworkTaxonomyContentPanel";
import { JSX, useState } from "react";
import { RouteComponentProps } from "react-router";
import { Redirect } from "react-router-dom";
import WizardStep from "@app/projects/create/WizardStep";

interface CreateProjectStepNetworkTaxonomyProps extends RouteComponentProps {
    networkTaxonomyData: NetworkTaxonomyData;
    onNetworkTaxonomyChange?: (networkTaxonomyData: NetworkTaxonomyData, isValid: boolean) => void;
    completionTracker: boolean[];
    baseUrl: string;
    progressList: string[];
    currentIndex: number;
    revertTaxonomyData: NetworkTaxonomyData;
}

function CreateProjectStepNetworkTaxonomy(props: CreateProjectStepNetworkTaxonomyProps): JSX.Element {
    const [restartApp] = useState<boolean>(!props.completionTracker.filter((_, index) => (props.currentIndex - 1) > index).every(step => step))
    const [isNextDisabled, setIsNextDisabled] = useState(false);

    const onNetworkTaxonomyChange = (networkTaxonomyData: NetworkTaxonomyData, isValid: boolean) => {
        if (props.onNetworkTaxonomyChange)
            props.onNetworkTaxonomyChange(networkTaxonomyData, isValid);

        setIsNextDisabled(!isValid);
    }

    if (restartApp) {
        return <Redirect to={`${props.baseUrl}/1`} />
    }
    return (
        <>
            <WizardStep
                heading="Create a New Project"
                subheading="Enter Network Taxonomy Details"
                baseUrl={props.baseUrl}
                prevUrl={(props.currentIndex - 1).toString()}
                nextUrl={(props.currentIndex + 1).toString()}
                progressList={props.progressList}
                isNextDisabled={isNextDisabled}
            >
                <div className="offset-2">
                    <NetworkTaxonomyContentPanel
                        networkTaxonomyData={props.networkTaxonomyData}
                        onNetworkTaxonomyChange={onNetworkTaxonomyChange}
                        disabled={false}
                    />
                </div>
            </WizardStep>
        </>
    );
}

export default CreateProjectStepNetworkTaxonomy;